// extracted by mini-css-extract-plugin
export default {"root":"TopicEmpty_root__9By6P","add":"TopicEmpty_add__KA3g9"};